import { render } from "./schedule-success.vue?vue&type=template&id=8981604e"
import script from "./schedule-success.vue?vue&type=script&lang=js"
export * from "./schedule-success.vue?vue&type=script&lang=js"

import "./schedule-success.vue?vue&type=style&index=0&id=8981604e&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__